/**
 * DOM: widget loaded inside its own iframe
 */
import createWidgetTemplateFactory from '../questiontypes/ImportFactories/ImportWidgetTemplateFactory';

import { BaseWidget } from '../core/BaseWidget';
//import RoundedDynamicUIController from './RoundedDynamicUIController';
import WidgetTypes from '../core/enums/WidgetTypes';
import TempCache from '../core/enums/TempCache';
import ParticipantIds from '../core/enums/ParticipantIds';
import WidgetView from '../core/WidgetView';
//import DOMUIController from './DOMUIController';
import DOMPositioner from '../core/positioners/DOMPositioner';
import getElementsByClassName from '../core/hooks/getElementsByClassName';
// import WebSmsFormValidator from '../core/hooks/WebSmsFormValidator';
import ADACompliant from '../core/hooks/ADACompliant';
import parseTemplate from '../core/hooks/parseTemplate';
import getStyle from '../core/hooks/getStyle';
import Browser from '../core/hooks/Browser';
import loadJQueryPlugins from '../core/loadJQueryPlugins';
import loadJQuery from '../core/hooks/loadJQuery';
import GlobalVariables from '../core/GlobalVariables';
import GetSkinTemplate from '../core/hooks/GetSkinTemplate';
import setDOMWindowStyles from '../core/hooks/setDOMWindowStyles';
import AgentImageHandler from '../core/hooks/AgentImageHandler';
import RunAsSoonAs from '../core/hooks/RunAsSoonAs';
import ChatStates from '../core/hooks/ChatStates';
import ChatEvents from '../core/hooks/ChatEvents';
import WidgetStates from '../core/hooks/WidgetStates';
import showElement from '../core/hooks/showElement';
import hideElement from '../core/hooks/hideElement';
import addClass from '../core/hooks/addClass';
import logIt from '../../logIt';
import getCookieValue from '../core/hooks/getCookieValue';
import checkSpanishLanguage from '../core/hooks/checkSpanishLanguage';
import throttleByFunctionName from '../core/hooks/throttleByFunctionName';
import PrechatMessagesGet from '../core/hooks/PrechatMessagesGet';
export default class DOMChatWindow extends BaseWidget {
    constructor(options) {
        super(Object.assign(options, { widget: WidgetTypes.DOM, $: module.defaults }));
        this.initiatedBy = 'Standard';
        this.language = null;
        this.interceptorResults = null;
        this.chatId = null;
        this.preLoadedOptions = null;
        this.resumable = false;
        this.closed = false;
        this.positioner = new DOMPositioner(this.options, this.DOM);

        this.ready();
    }

    ready() {
        super.ready();
        const me = this;
        const showIt = (args) => {
            if (args && args.value && args.value.visitorInfoId) {
                me.options.visitorInfoId = args.value.visitorInfoId;
            }
            if (!me.isWindowedStarted()) {
                me.maximize(args);
            }
        };
        this.subscribe(WidgetTypes.DropDown + WidgetStates.Clicked, showIt);
        this.subscribe(WidgetTypes.Bar + WidgetStates.Clicked, showIt);
        this.subscribe(WidgetTypes.Tab + WidgetStates.Clicked, showIt);
        this.subscribe(WidgetTypes.PreChat + WidgetStates.Clicked, (args) => {
            // CHAT-5649-InitiatedBy for preChat
            args.initiatedBy = args.initiatedBy || args.chatInitiatedBy; // define initiatedBy because we are getting argument initiatedBy from PreChat
            showIt(args);
        });
        this.subscribe(
            WidgetTypes.VideoGreetInvitation + WidgetStates.Clicked,
            function (args) {
                args.initiatedBy = args.initiatedBy || args.chatInitiatedBy; //define initiatedBy because we are getting argument initiatedBy from VideoGreetingInvitation
                showIt(args);
            }
        );
        this.subscribe(
            WidgetTypes.VisitorForm + WidgetStates.VisitorFormSubmitted,
            showIt
        );
        this.subscribe(WidgetTypes.DOMUIController + ChatEvents.OnChatReInit, () => {
            // when chat reinit DOM ui rerender so we need a state of DOMUIController rendererd on cookies
            me.state.changeState({
                origin: WidgetTypes.DOMUIController,
                toState: ChatStates.UIRendered
            });
            me.reInitChat();
        });
        this.subscribe(WidgetTypes.DOMUIController + WidgetStates.PoppedOut, () => {
            me.popout();
        });

        this.create();
    }

    create() {
        super.create();
        const me = this;
        me.show();
    }

    show() {
        const lastState = this.getCurrentState();
        super.show();

        const me = this;
        // if the chat options aren't preloaded, load them on-demand
        if (this.options.preloadEnabled) {
            me.preloadChatOptions(() => {
                me.preLoadedOptions = ApexChat.getPreloadedChatOptions();
                ApexChat.preLoadedOptions = me.preLoadedOptions;
                // me.state.changeState({ toState: WidgetStates.PreloadedChatOptions, value: true });
            });
        }
        // bypassing isPageRefreshed() in a special scenario: start new Chat with ChatEndedOverlay and then reloading page
        if (
            this.isPageRefreshed() ||
            lastState == WidgetStates.ShownMaximized ||
            lastState == WidgetStates.ShownMinimized ||
            lastState == WidgetStates.Closed
        ) {
            if (lastState == WidgetStates.ShownMaximized) {
                const lastDomUIState = this.state.getStateValue(WidgetTypes.DOMUIController); // Invitation Rendered maintain their state after refresh
                // setTimeout(function () {
                if (
                    me.isChatActive() ||
                    lastDomUIState === ChatStates.UIRendered ||
                    lastDomUIState === ChatEvents.OnChatRestart
                ) {
                    me.maximize();
                } else {
                    me.close();
                }
                // } 500);
            } else if (lastState == WidgetStates.ShownMinimized) {
                this.minimize();
            } else if (lastState == WidgetStates.Closed) {
                this.close();
            }
        } else {
            // do nothing on 1st page load; keep DOM object alive but not rendered on page
        }
    }

    // name should be changed; but its core purpose is to get Vew & Controller ready
    renderOpen() {
        const me = this;
        let tpl;
        const model = me.options;
        let styles = [];
        const chatModel = model;
        model.chatPoweredBy = model.poweredBy; // invitation handler knows poweredBy
        model.videoChat = ''; // obsolete
        tpl = me.options.chatWidgetTemplate;
        styles.push(me.options.chatCss);
        const cssTweaks =
            Browser.isIE() &&
                Browser.isQuirksMode() &&
                this.preLoadedOptions.quirksCss
                ? this.preLoadedOptions.quirksCss
                : null;
        me.uicontroller = null; // controller gets set on state transition: min or max because
        styles = [];
        const styleConfig = GetSkinTemplate(
            me.options.rdThemeSettings
        );

        setDOMWindowStyles(
            me.DOM, {
            ...styleConfig,
            webToText: {
                webToTextBackgroundColor: me.options.webToTextBackgroundColor,
                webToTextBackgroundGradientColor: me.options.webToTextBackgroundGradientColor,
                webToTextColorType: me.options.webToTextColorType,
            },
            isRDPlusTheme: ApexChat.IsRoundedDynamicPlusTheme,
        }
        );
        //styles.push(templateCss);
        // styles.push(me.options.rdThemeChat.rdDomActionMenuCss);
        tpl = me.options.rdThemeChat.chatWidgetTemplate;
        me.options.$ = me.$;
        me.options.context = me.DOM;
        const templateModel = (me, tpl) => {
            tpl.model = me.options;
            let chatTitleTemplate;
            let chatHeaderTemplate;
            chatTitleTemplate =
                me.options.profileTextsHash[me.options.language].chatTitleTemplate;
            chatHeaderTemplate =
                me.options.profileTextsHash[me.options.language].chatHeaderTemplate;
            tpl.model.chatTitle = parseTemplate(
                chatTitleTemplate || tpl.model.chatTitleTemplate,
                tpl.model
            );
            tpl.model.chatHeaderTemplate =
                chatHeaderTemplate || me.options.chatHeaderTemplate;
            if (me.options.headerDisclaimer) {
                tpl.model.headerDisclaimer = parseTemplate(
                    me.options.headerDisclaimer,
                    tpl.model
                );
            }
            if (me.options.disclaimer) {
                tpl.model.disclaimer = parseTemplate(
                    me.options.disclaimer,
                    tpl.model
                );
            }
            // TODO:Zeeshan:we will use just one out of the two similar functions   isInvitationSkinnableRoundedDynamic after RD skinnable version is completely implemented; probably in a next PR related to RD. For now the two are there to support both non-skinnable and skinnable.
            tpl.model.chatTitle = parseTemplate(
                me.options.rdThemeChat.chatTitleTemplate,
                tpl.model
            );
            tpl.model.chatHeaderTemplate =
                me.options.rdThemeChat.chatHeaderTemplate;
            tpl.model.chatMessageTemplate =
                me.options.rdThemeChat.chatMessageTemplate;
            tpl.model.handlerImageUrl = AgentImageHandler(me.options.handlerImageUrl);
            tpl.model.getFormatedDay = ApexChat.getFormatedDay("dddd, d MMMM");
            return tpl.model;
        }
        me.view = new WidgetView({
            identifier: WidgetTypes.DOM,
            dom: this.DOM,
            cssLinkId: 'DOMChatWindow',
            cssLink: `${GlobalVariables.CdnBaseUrl}contents/scripts/dist/${ApexChat.Theme}/domwindow.css?ver=${env.BUILD_HASH}`,
            style: cssTweaks,
            templates: [
                {
                    key: WidgetStates.ShownMaximized,
                    tpl: createWidgetTemplateFactory(templateModel(me, me.options.rdThemeChat)).chatDOMTemplate,
                    model, // we need both options above to have some complete stuff for rendering ChatWidget
                    style: styles,
                    beforeRender(tpl) {

                    },
                    async afterRender(tpl) {
                        const view = this;


                        await loadJQuery()
                        loadJQueryPlugins(ApexChat.ApexChatJquery)
                        showElement(me.options.parentDivId); // this line fixes flicker while showing ; ref.CHAT - 5570
                        const el = this.DOM.getElementById('apexchat_dompopup_chatwindow_max');

                        if (me.options.hasSmsNumber) {
                            me.options.phoneWarningSelector = '.apexchat_error_message';
                            const module = await import(/* webpackChunkName: "webSmsFormValidator" */ '../core/hooks/WebSmsFormValidator')
                            const WebSmsFormValidator = module.default
                            const smsForm = WebSmsFormValidator(me.options);
                            smsForm.init();
                            smsForm.reset();
                            smsForm.bind();
                            var webToSmsSubmitButton = me.DOM.querySelector('.ep-submit-button', me.DOM);
                            webToSmsSubmitButton.addEventListener('click', () => {
                                throttleByFunctionName(() => {
                                    webToSmsSubmitButton.text = 'Sending...';
                                    webToSmsSubmitButton.classList.add('pointer-event-none');
                                    if (!me.uicontroller.isChatroomAlive()) { // if chatroom is not alive and user click on transfer chat option
                                        me.createChatAndLoadChatRoom(function () {
                                            //hack to resize the textarea - bringing focus back to textarea
                                            me.uicontroller.messageInput.focus();
                                            me.chatStarted = true;
                                            me.handleADA(me.uicontroller.clickButton[0], me.uicontroller.sendMessage.bind2(me.uicontroller));
                                            RunAsSoonAs(function () {
                                                ApexChat.ApexChatJquery('.submit-button', me.DOM).click();
                                                me.uicontroller.firstMsgSent = true; 
                                                ApexChat.ApexChatJquery('.ep-submit-button', me.DOM).text('Continue').removeClass('pointer-event-none');

                                            }, function () {
                                                return getCookieValue('livechat_chat_id') > 0;
                                            })
                                        });
                                        me.options.chatTransfer = true;
                                        me.uicontroller.showTyping();
                                    } else {
                                        ApexChat.ApexChatJquery('.ep-submit-button', me.DOM).text('Continue').removeClass('pointer-event-none');
                                        ApexChat.ApexChatJquery('.submit-button', me.DOM).click();
                                    }
                                }, 7, 'transferWebToTextEP')();
                            });

                        }
                        // ADA Compliance
                        // summary: CSS Class 'apexchat_ada_compliance' has no CSS Styling behind it means it won't effect on UI.
                        // Its only for detecting the ADA Complianced HTML elements on which we do need to have the TAB Focus.
                        // This is the Utility function which takes all HTML elements having the class 'apexchat_ada_compliance' as ARRAY, and apply the TabIndex on all of them.
                        ADACompliant.push(
                            me.DOM.querySelector('.apexchat_ada_compliance')
                        ).apply();
                        let computedHeight = el.offsetHeight;
                        // CHAT-6540 - TextArea Height and margin from bottom is depend on "poweredby" TAG, handling logic in this wrapper function.
                        me.handlePoweredByVisibility();
                        // To visible the shadow of RD;
                        const headerComputedHeight = getElementsByClassName(
                            this.DOM,
                            'apexchat_rd_chat_header'
                        )[0].offsetHeight;
                        const poweredByComputedHeight =
                            getElementsByClassName(this.DOM, 'apexchat_poweredby')[0]
                                .offsetHeight + 17;
                        const paddingAdjustmentsInPixels = 164 + 30; // CHAT-7395 - 60px added as we removed height: calc(100% - 64px) which was causing Iframe trimming
                        computedHeight =
                            computedHeight +
                            headerComputedHeight +
                            poweredByComputedHeight +
                            paddingAdjustmentsInPixels;

                        const module = await import(/* webpackChunkName: "roundedDynamicUIController" */ '../dom/RoundedDynamicUIController')
                        const RoundedDynamicUIController = module.default;
                        me.uicontroller = new RoundedDynamicUIController({
                            model: tpl.model,
                            chatModel,
                            elements: this.elements,
                            context: me.DOM,
                            ADAHandler: me.handleADA.bind2(me),
                            createChatAndLoadChatRoom: me.createChatAndLoadChatRoom.bind2(me),
                            execChatStartHandler: me.createChatAndLoadChatRoom.bind2(me)
                        });
                        me.uicontroller.initRestartOverlay();
                        me.uicontroller.initAgentNotFoundOverlay('#apexchat');
                        me.uicontroller.initVideoGreetOverlay();
                        // restartchat toggle function for DOM
                        me.uicontroller.bindRestartChatEvents(
                            me.DOM.querySelector(me.uicontroller.options.elements.restartVAChatSelector,), true);
                        me.uicontroller.bindVolumeMuteEvents(
                            me.DOM.querySelector(me.uicontroller.options.elements.volumeMuteUnmute),
                            me.uicontroller.toggleMuteClass
                        );
                        me.uicontroller.toggleMuteClass(
                            me,
                            me.DOM.querySelector(me.uicontroller.options.elements.volumeMuteUnmute)
                        );
                        me.uicontroller.bindTransferChatEvents(
                            me.DOM.querySelector(me.uicontroller.options.elements.transferChatSelector),
                            true
                        );
                        // following will check if there are non sms languages
                        // if yes that will call a function implementMultiLanguageSupport to render further
                        me.uicontroller.renderMultiLanguageDropDown();
                        me.uicontroller.toggleLanguageBottomSheet(
                            me.DOM.querySelector(
                                me.uicontroller.options.elements.actionMenuLanguageSwitcher
                            )
                        );
                        me.uicontroller.toggleLanguageBottomSheet(
                            me.DOM.querySelector(
                                me.uicontroller.options.elements.languageBottomSheetClose
                            )
                        );
                        me.uicontroller.toggleSMSNumberInput(
                            me.DOM.querySelectorAll(
                                me.uicontroller.options.elements.actionMenuStartSMSChat
                            ), {
                            container: "#apexchat_rd_chat_content",
                            element: "#switchto-text-chat-in-content"
                        }
                        );
                        me.uicontroller.toggleSMSNumberInput(
                            me.DOM.querySelectorAll(me.uicontroller.options.elements.smsBottomSheetClose)
                        );
                        // }
                        //  else {
                        //     me.uicontroller = new me.DOMUIController({
                        //         model: tpl.model,
                        //         chatModel,
                        //         elements: this.elements,
                        //         context: me.DOM,
                        //         ADAHandler: me.handleADA.bind2(me)
                        //     });
                        // }
                        // smoothly show dom if video greet is enabled
                        if (me.options && me.options.videoGreetEnabled) {
                            ApexChat.WidgetMaximizedWidth = me.options.videoGreet.persistVideoRatioForWidget
                                ? ApexChat.IsRoundedDynamicPlusTheme ? 458 : 366
                                : 380;
                            ApexChat.WidgetMaximizedHeight = me.options.videoGreet.persistVideoRatioForWidget
                                ? 650
                                : 508;
                            el.classList.add('apexchat_dompopup_expand_from_video_greet');
                            var container = me.DOM.querySelector('#apexchat_dompopup_chatwindow_max');
                            // var iframe = me.$('#' + me.options.iframeId);
                            // container.hide().fadeIn(); TODO:// need to find alternate of fadein
                            container.style.transition = 'opacity 0'
                            container.style.transition = 'opacity 400ms'

                            var iframe = document.querySelector('#' + me.options.iframeId);
                            container.style.display = 'none';
                            if (me.options.videoGreet.persistVideoRatioForWidget) {
                                iframe.classList.add('apexchat_dompopup_persist_video_size');
                                container.classList.add('apexchat_dompopup_height_with_ratio');
                            }
                        }
                        me.uicontroller.show(tpl.key); // _max or _min
                        // in firefox isMobile is coming as false for mobiles. due to this reason we had to use useragent and width
                        if (
                            !me.options.isMobile &&
                            !(/Firefox/.test(navigator.userAgent) && window.innerWidth < 800)
                        ) {
                            addClass(
                                me.DOM.getElementById('apexchat_rd_chat_content'),
                                'apexchat_rd_desktop_widget_height'
                            );
                        }
                        me.handleADA(
                            me.uicontroller.clickButton,
                            me.uicontroller.sendMessage.bind2(me.uicontroller)
                        );
                        me.handleADA(
                            me.uicontroller.closeButton,
                            me.uicontroller.end.bind2(me.uicontroller)
                        );
                        me.handleADA(
                            me.uicontroller.minimizeButton,
                            me.uicontroller.minimize.bind2(me.uicontroller)
                        );
                        me.handleADA(me.uicontroller.popoutButton, () => {
                            me.popout();
                        });
                        if (!me.options.skinnable) {
                            addClass(el, 'apexchat_dompopup_chatwindow_nonskinnable');
                            computedHeight += 30;
                        }

                        // me.$('.livechat_title', me.DOM).addClass('apexchat_blur');
                        // me.$('.apexchat_participants', me.DOM).addClass('apexchat_blur');
                        // me.$('.apexchat_poweredby', me.DOM).addClass('apexchat_blur');
                        // me.$('.apexchat_intro', me.DOM).addClass('apexchat_blur');
                        logIt('positioning...');
                        //me.hide()
                        me.positioner.position({
                            element: me.options.parentDivId,
                            widgetType: WidgetTypes.DOM,
                            model: {
                                options: tpl.model,
                                computedHeight
                            },
                            context: document
                        });
                        // showElement(this.DOM.querySelector('#apexchat_dompopup_chatwindow_max'));

                        if (me.options && me.options.domADACss) {
                            // apply ADA CSS when user zooming the widget.
                            // handleZooming(
                            //     me.options.domADACss,
                            //     'apexchat_Iframe_dom_ada_css',
                            //     me.DOM
                            // );
                        }
                        me.hideLoading();
                    }

                }
            ]
            // initialState: WidgetStates.ShownMaximized
        });
        import(/* webpackChunkName: "roundedDynamicUIController" */ './RoundedDynamicUIController').then(
            (module) => {
                me.showLoading();
                me.RoundedDynamicUIController = module.default;
                me.view.render(WidgetStates.ShownMaximized);
            }
        );
    }

    minimize() {
        super.minimize(); // TODO: need to remove this as DOM does not have min state; should be me.hide() instead
        hideElement(this.options.parentDivId); // CHAT-5294
    }

    maximize(args) {
        const me = this;
        me.postMessage({ event: 'rounded-dynamic-preserve-scroll-before-maximizing' }); // to add custom behavior; TODO: we have to get rid of this conditional approach; it's messy
        super.maximize(); // change state to _max, always
        if (ApexChat.localStorageAPI.Get('sms_bottomsheet_opened_forcefully')) {
            RunAsSoonAs(function () {
                const actionMenuStartSMSChat = me.DOM.querySelector(me.uicontroller.options.elements.actionMenuStartSMSChat);
                if (actionMenuStartSMSChat) { //to make sure chat hasnot ended as we hide it on chat end
                    me.context = me.DOM;
                    me.toggleSmsBottomSheet();
                }
            }, function () {
                return getCookieValue('livechat_chat_id') > 0;
            })
            ApexChat.localStorageAPI.Remove('sms_bottomsheet_opened_forcefully');
        }
        if (me.uicontroller) {
            // DOM Chat already intact? just show it
            if (me.uicontroller.needChatRoomCreation()) {
                me.createChatAndLoadChatRoom(() => {
                    me.options.launchChatWindowEnabled = false;
                })
            }
            me.uicontroller.autoScroll();
            /* CHAT-5710 & CHAT-9178 - Prevent Background scrolling on mobile view
             * Applied class for scroll hidden on mobile view
             */
            me.uicontroller.handleParentScroll && me.uicontroller.handleParentScroll(true);
            return;
        }
        if (args) {
            if (args.selectedLanguage) {
                me.options.language = args.selectedLanguage;
            }
            me.initiatedBy = args.initiatedBy || args.chatInitiatedBy;
            me.interceptorResults = args.interceptorResults;
        }
        logIt('maximize');

        this.query = me.getQueryString(false, true);

        if (me.chatStarted && this.chatStartOptions && this.chatStartOptions.chatId) {
            // check dom last state if its closed then resubscribe websync client
            if (me.getCurrentState() == WidgetStates.Closed) {
                me.uicontroller.messagesContainer.html('');
                me.uicontroller.introContainer.hide();
                me.uicontroller.participantsContainer.show();
                me.reInitChat();
            } else {
                me.DOM.querySelector(me.view.elements.containerSelector).style.display = 'block';
                me.uicontroller.show(WidgetStates.ShownMaximized);
            }
        } else {
            if (this.chatId) {
                this.query += `&chatId=${this.chatId}`;
            }
            if (me.isAlreadyChatCreated) {
                // if chat is already created then return false
                return false;
            }
            me.isAlreadyChatCreated = true; // is already chat create
            me.renderOpen();
            /* CHAT-5907 CHAT-5908 
             checking ApexChatStartData is not on DOM,
             when EP show before DOM chat start and then user move back to DOM without sending any msg then DOM's ApexChatStartData remain undefined */
            if (!ApexChat.preLoadedOptions || typeof ApexChatStartData === 'undefined') {
                if (ApexChat.options.launchChatWindowEnabled && !me.options?.isMobile && !me.getChatId()) {
                    RunAsSoonAs(() => {
                        if (me.uicontroller) {
                            logIt('opening chat room...');
                            var prechatMessages = me.options.preChat?.preChatMessages;
                            if (me.options.preChat?.preChatMessages?.length === 0) {
                                prechatMessages = PrechatMessagesGet();
                            }
                            if (prechatMessages) {
                                prechatMessages.forEach(function (prechatMessage, index, array) {
                                    var message = prechatMessage.agentScript || prechatMessage;
                                    message.userId = TempCache.EP_PREDEFINED_AGENT_ID;
                                    message.agentParticipantId = ParticipantIds.predefined;
                                    message.scriptAnswerId = prechatMessage.agentScriptAnswerId;
                                    message.isSimulatePredefinedMessage = true;
                                    message.message = message.message || message.text;
                                    message.answerScript = { ...prechatMessage.agentScript };
                                    me.uicontroller.renderPredefinedQTs(message);
                                });
                            }

                            clearInterval(isViewRendered);
                        }
                    }, () => me.uicontroller != null);
                } else {
                    logIt('preloading options...');
                    me.createChatAndLoadChatRoom();
                }

            } else {
                me.preLoadedOptions = ApexChat.getPreloadedChatOptions();
                ApexChat.preLoadedOptions = me.preLoadedOptions;
                var isViewRendered = setInterval(() => {
                    if (me.uicontroller) {
                        logIt('re-loading chat room...');
                        me.uicontroller.loadChatRoom();
                        clearInterval(isViewRendered);
                    }
                }, 300);
            }
        }
    }
    createChatAndLoadChatRoom(cb) {
        const me = this;
        me.preloadChatOptions(() => {
            logIt('exec chat start...');
            me.execChatStartHandler(() => {
            logIt('loading chat room...');
            RunAsSoonAs(
                () => {
                    if (cb) {
                        me.uicontroller.introContainer?.innerHTML = "Starting chat..."
                    }
                    me.uicontroller.loadChatRoom(() => {
                        if (cb) {
                            RunAsSoonAs(
                                () => {
                                    cb()
                                    const initialChat = checkSpanishLanguage(me.options)
                                        ? `Chateando con ${me.options.agentName}`
                                        : `Chatting with ${me.options.agentName}`;
                                    me.uicontroller.introContainer?.innerHTML = initialChat;

                                },
                                () => me.uicontroller.isChatroomAlive()
                            );
                        }
                    });
                },
                () =>
                    // Check uicontroller and loadChatRoom before calling them..
                    !!me.uicontroller && !!me.uicontroller.loadChatRoom
            );
            logIt('chat room loaded.');
        });
        });

    }
    popout() {
        const me = this;
        if (me.uicontroller.needChatRoomCreation()) {
            me.createChatAndLoadChatRoom(() => {
                me.uicontroller.publishPredefinedMessages(() => {
                    this.startWindowedChat();
                })
            })
        }
        else {
            this.startWindowedChat();
        }
    }
    startWindowedChat() {
        super.popout();
        // CHAT-6897 - need to stop the events subscription of dom if CHAT has been popedup to Windowed Chat.
        if (this.uicontroller) {
            this.uicontroller.clearAllSubscriptions();
        }
    super.startWindowedChat(this.options);
        this.minimize();
}
    close() {
        super.close();
        // me.uicontroller.end();
    }

    showLoading() {
        // this.hideLoading();

        // show the loading indicator
        // const loadingIndicator = document.createElement('div');
        // const container = document.getElementById('apexchat_DOM_loading');
        // const opacity = 4;

        // loadingIndicator.id = 'apexchat_invitation_loading_indicator';
        // loadingIndicator.style.position = 'absolute';
        // loadingIndicator.style.left = '0';
        // loadingIndicator.style.top = '0';
        // loadingIndicator.style.width = '100%';
        // loadingIndicator.style.height = '100%';
        // loadingIndicator.style.backgroundColor = '#fff';
        // loadingIndicator.style.textAlign = 'center';
        // loadingIndicator.style.opacity = opacity / 10;

        // loadingIndicator.style.filter = `alpha(opacity=${opacity * 10})`;

        // const img = document.createElement('img');
        // img.src = `${GlobalVariables.ApexChatBaseUrl}contents/images/spinner.gif`;
        // img.alt = 'Loading...';
        // // container.appendChild(loadingIndicator);
        // loadingIndicator.appendChild(img);
        // const txt = document.createTextNode('Loading...');
        // loadingIndicator.appendChild(txt);

        // loadingIndicator.style.paddingTop = `${(container.offsetHeight - img.offsetHeight) / 2}px`;
    }

    hideLoading() {
        // // hide the loading indicator
        // const node = document.getElementById('apexchat_invitation_loading_indicator');

        // if (node) {
        //     node.parentNode.removeChild(node);
        // }
    }

    handlePoweredByVisibility() {
        const me = this;
        const styleConfig = GetSkinTemplate(
            me.options.rdThemeSettings
        );
        const isPoweredByHidden = styleConfig?.rdChat?.poweredBy?.hidePoweredBySection
        let wrapper = me.DOM.querySelector('#apexchat_dompopup_chatwindow_max');

        if (isPoweredByHidden) {
            wrapper.classList.add('livechat_powered_by_hidden');
            // me.DOM.querySelector('#apexchat .apexchat_rd_input_wrapper').style.height = '50px';
        } else {
            wrapper.classList.remove('livechat_powered_by_hidden');
        }
    }
}
